{
  "title": "Feign Death",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level necromancy (ritual)",
  "level": 3,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a pinch of graveyard dirt)",
  "duration": "1 hour",
  "description": [
    "You touch a willing creature and put it into a cataleptic state that is indistinguishable from death.",
    "For the spell’s duration, or until you use an action to touch the target and dismiss the spell, the target appears dead to all outward inspection and to spells used to determine the target’s status. The target is blinded and incapacitated, and its speed drops to 0. The target has resistance to all damage except psychic damage. If the target is diseased or poisoned when you cast the spell, or becomes diseased or poisoned while under the spell’s effect, the disease and poison have no effect until the spell ends."
  ],
  "spellLists": ["bard", "cleric", "druid", "wizard"]
}
